import http from "../utils/http";
let resquest = "https://apipxb.yunvip123.com/api";
// let resquest = "https://t-apipxb.yunvip123.com/api";
// let resquest = "http://127.0.0.1:5000/api";
// let resquest = "https://pxbapi.getdreamstar.com/api";

export function apiPost(url, param) {
  return http.post(`${resquest + url}`, param);
}



// WEBPACK FOOTER //
// ./src/api/api.js